<template>
    <div class="seismic-safety-video">
        <div class="container">
            <div class="section-title">
                <h3>{{ pageSetup.safety_news_video }}</h3>
                <div class="link-of-page" v-if="setup != null">
                    <router-link to="/video-safety">
                        <span>{{ setup.btn_bazis_video_home }}</span>
                        <svgIcon name="arrow-go-right"/>
                    </router-link>
                </div>
            </div>
            <div class="video-seismic-items" v-if="videoItems != null">
                <div class="video-item-seismic-safety" v-for="item in videoItems">
                    <a href="#" class="link-open-modal" @click.prevent="openVideoModal(item.acf.title, item.acf.video_link)">
                        <svgIcon name="play" class="icon-play"/>
                        <div class="video-item-img">
                            <img :src="item.acf.video_preview" alt="">
                        </div>
                        <div class="video-title">
                            <h2>{{item.acf.title}}</h2>
                        </div>
                    </a>
                </div>
            </div>
            <modal name="video-modal-safety" 
                @before-close="beforeVideoModalClose" 
                @closed="videoModalClosed" 
                :transition="transitionName" 
                :width="modalWidth" 
                :height="modalHeight" 
                :scrollable="modalScrollable"  
                class="video-modal-safety"               
                id="video-modal-safety">
                <div class="modal-content" v-if="modalData.title != null && modalData.link != null">
                    <div class="video-title">
                        <h2>{{modalData.title}}</h2>
                    </div>
                    <div class="video-player">
                        <iframe :src="modalData.link + '?autoplay=1&loop=1&rel=0&showinfo=0&vq=highres&color=white&iv_load_policy=3'" frameborder="0" allow="autoplay" allowfullscreen></iframe>
                    </div>
                    <a href="#" class="close-link" @click.prevent="closeVideoModal">
                        <svgIcon name="close" class="icon-close"/>
                    </a>
                </div>
            </modal>
            <div class="link-of-page-mobile" v-if="setup != null && isMobileChecker">
                <router-link to="/video-safety">
                    <span>{{ setup.btn_bazis_video_home }}</span>
                    <svgIcon name="arrow-go-right"/>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'seismic-safety-video',
        components: {
            svgIcon,
        },
        data () {
            return {
                transitionName: 'pop-out',
                modalWidth: 1000,
                modalHeight: 'auto',
                modalScrollable: false,
                modalData: {
                    title: null,
                    link: null
                },
            }
        },
        computed: mapGetters({
            pageSetup: 'loadSeismicSafetyPage',
            videoItems: 'loadSeismicSafetyVideoItems',
            setup: 'loadPageSetUp',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            getSafetyVideoItems() {
                if (this.pageSetup != null) {
                    const data = this.pageSetup.safety_video;
                    var id_str = '';
                    for (var i=0; i<data.length; i++) {
                        id_str = id_str + data[i].video.ID
                    }
                    var correct_str = id_str.match(/.{1,4}/g);
                    var id_s = correct_str.join(",");
                    this.$store.dispatch('getSeismicSafetyVideoByIDs', id_s);
                }
            },
            startLoader() {
                this.$parent.$parent.$refs.topProgress.start();
            },
            openVideoModal(title, link) {
                this.modalData.title = title;
                this.modalData.link = link;
                this.$modal.show('video-modal-safety');
                document.getElementsByTagName('body')[0].classList.add('video_open');
                document.getElementById('header').classList.add('notvisible');
            },
            closeVideoModal() {
                this.$modal.hide('video-modal-safety');
                document.getElementsByTagName('body')[0].classList.remove('video_open');
                document.getElementById('header').classList.remove('notvisible');
            },
            beforeVideoModalClose() {
                document.getElementsByTagName('body')[0].classList.remove('video_open');
                document.getElementById('header').classList.remove('notvisible');
            },
            videoModalClosed() {
                document.getElementsByTagName('body')[0].classList.remove('video_open');
                document.getElementById('header').classList.remove('notvisible');
            }
        },
        created () {
        },
        mounted() {
            this.getSafetyVideoItems();
            this.$store.watch(
                (state) => state.seismicSafetyPage,
                (newValue) => {
                    if (newValue) 
                    this.getSafetyVideoItems();
                }
            );
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/seismic-safety/seismic-safety-video.scss';
    @import '@/styles/components/seismic-safety/respond/seismic-safety-video-respond.scss';
    // @import '@/styles/components/about/respond/about-us-section-respond.scss';
</style>